<template>
  <div class="min-h-screen bg-theme-bg flex flex-col items-center justify-center p-6">
    <div class="bg-theme-card rounded-2xl shadow-xl p-8 md:p-10 text-center max-w-md w-full transform transition-all duration-300 hover:shadow-2xl">
      <div class="mb-6 animate-bounce">
        <i class="pi pi-map text-6xl text-secondary-500"></i>
      </div>
      
      <h1 class="text-4xl sm:text-5xl font-extrabold text-theme-text mb-3 tracking-tight">
        <span class="text-theme-text">404</span> - Page Not Found
      </h1>
      
      <p class="text-lg text-theme-text2 mb-6">
        Oops! The page you're looking for has wandered off. Let's get you back on track.
      </p>
      
      <div class="space-y-4">
        <RouterLink
          to="/"
          class="block w-full bg-neutral-900 text-white py-3 px-6 rounded-lg font-bold text-base hover:bg-neutral-800 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:ring-offset-2"
          aria-label="Return to home page"
        >
          <i class="pi pi-home mr-2"></i> Go to Homepage
        </RouterLink>
        
        <button
          @click="goBack"
          class="block w-full bg-theme-card text-theme-text py-3 px-6 rounded-lg font-bold text-base border border-theme-border hover:bg-theme-bg2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:ring-offset-2"
          aria-label="Go back to previous page"
        >
          <i class="pi pi-arrow-left mr-2"></i> Go Back
        </button>
      </div>
      
      <div class="mt-8 pt-6 border-t border-theme-border">
        <p class="text-sm text-theme-muted mb-2">Still lost? Try these helpful links:</p>
        <div class="flex justify-center space-x-4">
          <RouterLink 
            to="/categories" 
            class="text-sm text-theme-text hover:text-secondary-500 transition-colors"
            aria-label="Browse categories"
          >
            Browse
          </RouterLink>
          <RouterLink
           to="/terms-conditions" 
           class="text-sm text-theme-text hover:text-secondary-500 transition-colors"
           >
           Terms
          </RouterLink>
          <RouterLink
           to="/privacy-cookie-notice" 
           class="text-sm text-theme-text hover:text-secondary-500 transition-colors"
           >
           Privacy Policy
          </RouterLink>

          <RouterLink 
            to="/contact" 
            class="text-sm text-theme-text hover:text-secondary-500 transition-colors"
            aria-label="Contact support"
          >
            Contact Us
          </RouterLink>
        </div>
      </div>
    </div>
    
    <div class="mt-8 text-center">
      <p class="text-xs text-theme-muted">
        Error code: 404 | {{ new Date().toLocaleDateString() }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push('/');
  }
};
</script>

<style scoped>
.animate-bounce {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}

/* Smooth transitions for interactive elements */
a, button {
  transition: all 0.2s ease;
}

</style>